<script>
export default {
  name: 'AdminApp',
};
</script>

<template>
  <div id="app">
    <v-app id="v-app">
      <router-view />
    </v-app>
  </div>
</template>

<style lang="scss" scoped>
#app {
  width: 100vw;
  background-color: white;
}
</style>
